



















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import fetch from '@/common/api/fetch';

import { pickHtmlTextContent } from '@/common/utils/dealWithString';
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import { exchangeMsgToXcx, wechatSignUp } from '@/common/utils/wechatFunc';

import { AxiosPromiseData, AxiosPromiseError, ShareObjectInterface, SignatureData } from '@/common/interface';
import CONFIG from '@/common/config';

@Component
export default class GroupJoinFooter extends Vue {
  @Getter('section') section!: any;
  @Getter('gradientColor') gradientColor!: string;
  @Getter('uid') uid!: string;
  @Getter('urlUid') urlUid!: string;
  @Getter('qrCodeUrl') qrCodeUrl!: string;
  @Getter('openId') openId!: string;
  @Getter('title') title!: string;
  @Getter('joinNumber') joinNumber!: number;
  @Getter('signature') signature!: SignatureData;
  @Getter('coverTiny') coverTiny!: string;
  @Getter('groupFull') groupFull!: boolean;
  @Getter('showFooter') showFooter!: boolean;
  @Getter('showJoinFooter') showJoinFooter!: boolean;
  @Getter('joinGroupFlag') joinGroupFlag!: boolean;
  @Getter('payType') payType!: string;
  @Getter('payNumber') payNumber!: number;
  @Getter('hasPay') hasPay!: number;
  @Getter('startTime') startTime!: number;
  @Getter('deadline') deadline!: any;
  @Getter('orgId') orgId!: string;
  @Getter('posterName') posterName!: string;
  @Getter('courseType') courseType!: string;
  @Getter('selectedSeqNo') selectedSeqNo!: number;
  @Getter('cancel') cancel!: boolean;
  @Getter('nickname') nickname!: string;
  @Getter('avatar') avatar!: string;
  @Getter('myReward') myReward!: string;

  @Action('changeJoinNumber') changeJoinNumber!: Function;
  @Action('changeUid') changeUid!: Function;
  @Action('changeUrlUid') changeUrlUid!: Function;
  @Action('changeGroupNumber') changeGroupNumber!: Function;
  @Action('changeJoinGroupFlag') changeJoinGroupFlag!: Function;
  @Action('changePosterUrl') changePosterUrl!: Function;
  @Action('changeLeadersInstId') changeLeadersInstId!: Function;

  templateType: string = getActivityType() as string;
  type: string = getUrlParam('type') as string;
  broadcastId: string = getUrlParam('broadcastId') as string;
  show: boolean = false;
  showJoin: boolean = false;
  originatorId: string = '';
  leadersInstId?: string;
  leaderId: string = '';
  groupFlag: boolean = true; // 当前团是否存在
  activityStatus: string = '';
  statusInterval: any = {};
  mounted() {
    // this.interval = setInterval(()=>{
    //   this.leftPayTime();
    //   const overTime = (Number(new Date()) - this.distributeOrderCreateTime > (15*60*1000));
    //   this.overTime = overTime;
    // },1000)
    this.statusInterval = setInterval(() => {
      this.getActivityStatus();
    }, 50);
  }

  @Watch('urlUid')
  getCurrentGroup() {
    if (!this.urlUid) return null;
    const param = {
      activityId: getUrlParam('broadcastId'),
      userId: this.urlUid
    };
    fetch.Sales('anon/distributeGroup/getCurrentGroup', param).then((res: AxiosPromiseData) => {
      if (res.result) {
        const {
          result: { leadersInstId, leaderId }
        } = res;
        this.leadersInstId = leadersInstId;
        this.leaderId = leaderId;
        this.groupFlag = true;
      } else {
        this.groupFlag = false;
      }
    });
  }

  handleShowJoinModal(originatorId: string = '') {
    if (new Date().valueOf() < this.startTime) {
      Vue.$toast.error('活动未开始');
      return;
    }
    if (originatorId) {
      this.originatorId = originatorId;
    }
    this.changeLeadersInstId(this.leadersInstId);
    // 未报名或者已经报名但是没有支付
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const host: string = location.host;
    const tempStr: string = env === 'gray' ? '/xmpay' : '/xmpay';

    if (!this.uid || (this.uid && this.hasPay !== 4)) {
      // 跳转到小程序支付页面
      if (window.__wxjs_environment === 'miniprogram') {
        const promoterId = getUrlParam('promoterId');
        const referralId = getUrlParam('referralId');
        const broadcastId = getUrlParam('broadcastId');
        const distributorId = getUrlParam('distributorId');
        let qrCodeUrl = this.qrCodeUrl;
        if (env === 'gray') {
          qrCodeUrl = qrCodeUrl.replace('xmshow', 'xmshow/gray');
        }
        const scene =
          `activityId=${broadcastId}&nickname=${this.nickname}&avatar=${this.avatar}&originatorId=${this.originatorId}&qrCodeUrl=${encodeURIComponent(
            qrCodeUrl
          )}` +
          (this.leadersInstId ? `&leadersInstId=${this.leadersInstId}` : '') +
          `&distributorId=${distributorId ? distributorId : '-1'}` +
          (promoterId ? `&promoterId=${promoterId}` : '') +
          (referralId ? `&referralId=${referralId}` : '') +
          (this.urlUid ? `&parentUid=${this.urlUid}` : '') +
          (this.selectedSeqNo ? `&seqNo=${this.selectedSeqNo}` : '');
        window.wx.miniProgram.navigateTo({
          url: `/pages/pay-detail/index?${scene}&joinType=true`
        });
      }
    } else {
      // 已报名,跳转到小程序支付结结果页面
      if (window.__wxjs_environment === 'miniprogram') {
        const broadcastId = getUrlParam('broadcastId');
        let qrCodeUrl = this.qrCodeUrl;
        if (env === 'gray') {
          qrCodeUrl = qrCodeUrl.replace('xmshow', 'xmshow/gray');
        }
        const scene = `activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(qrCodeUrl)}`;
        window.wx.miniProgram.redirectTo({
          url: `/pages/pay-distributeGroup-result/index?${scene}`
        });
      } else {
        const targetUrl: string =
          'https://' +
          host +
          tempStr +
          (env === 'prod' || env === 'gray' ? '/index.html' : '/') +
          '#/xmx_group_pay_result?userOpenId=' +
          this.openId +
          '&broadcastId=' +
          getUrlParam('broadcastId');
        location.href = targetUrl;
      }
    }
  }

  handleShowOpenModal() {
    if (new Date().valueOf() < this.startTime) {
      Vue.$toast.error('活动未开始');
      return;
    }
    // 如果活动已过期，则弹窗
    if (new Date().valueOf() > Number(this.deadline)) {
      Vue.$confirm({
        oneBtn: true,
        title: '来晚啦',
        text: '活动已结束！',
        okText: '确定'
      });
      return;
    }
    this.changeLeadersInstId('');
    // 未报名或者已经报名但是没有支付
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const host: string = location.host;
    const tempStr: string = env === 'gray' ? '/xmpay' : '/xmpay';

    if (!this.uid || (this.uid && this.hasPay !== 4)) {
      // 跳转到小程序支付页面
      if (window.__wxjs_environment === 'miniprogram') {
        const promoterId = getUrlParam('promoterId');
        const referralId = getUrlParam('referralId');
        const broadcastId = getUrlParam('broadcastId');
        const distributorId = getUrlParam('distributorId');
        let qrCodeUrl = this.qrCodeUrl;
        if (env === 'gray') {
          qrCodeUrl = qrCodeUrl.replace('xmshow', 'xmshow/gray');
        }
        const scene =
          `activityId=${broadcastId}&nickname=${this.nickname}&avatar=${this.avatar}&qrCodeUrl=${encodeURIComponent(qrCodeUrl)}` +
          `&distributorId=${distributorId ? distributorId : '-1'}` +
          (promoterId ? `&promoterId=${promoterId}` : '') +
          (referralId ? `&referralId=${referralId}` : '') +
          (this.urlUid ? `&parentUid=${this.urlUid}` : '');
        window.wx.miniProgram.navigateTo({
          url: `/pages/pay-detail/index?${scene}`
        });
      }
    } else {
      // 已报名,跳转到小程序支付结结果页面
      if (window.__wxjs_environment === 'miniprogram') {
        const broadcastId = getUrlParam('broadcastId');
        let qrCodeUrl = this.qrCodeUrl;
        if (env === 'gray') {
          qrCodeUrl = qrCodeUrl.replace('xmshow', 'xmshow/gray');
        }
        const scene = `activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(qrCodeUrl)}`;
        window.wx.miniProgram.redirectTo({
          url: `/pages/pay-distributeGroup-result/index?${scene}`
        });
      } else {
        const targetUrl: string =
          'https://' +
          host +
          tempStr +
          (env === 'prod' || env === 'gray' ? '/index.html' : '/') +
          '#/xmx_group_pay_result?userOpenId=' +
          this.openId +
          '&broadcastId=' +
          getUrlParam('broadcastId');
        location.href = targetUrl;
      }
    }

    try {
      // 链接上有uid为二级页面，没有则为一级页面
      // 统计一级活动页报名数
      if (!getUrlParam('uid')) {
        window.TDAPP.onEvent('一级活动页报名数', '团购');
      } else {
        // 统计二级页面浏览数
        window.TDAPP.onEvent('二级活动页报名数', '团购');
      }
    } catch (error) {
      throw new Error(error);
    }
  }

  // 查看我的报名记录
  handleViewMyRecord() {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const host: string = location.host;
    // 已报名,跳转到小程序支付结结果页面
    if (window.__wxjs_environment === 'miniprogram') {
      const broadcastId = getUrlParam('broadcastId');
      let qrCodeUrl = this.qrCodeUrl;
      if (env === 'gray') {
        qrCodeUrl = qrCodeUrl.replace('xmshow', 'xmshow/gray');
      }
      const scene = `activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(qrCodeUrl)}`;
      window.wx.miniProgram.navigateTo({
        url: `/pages/pay-distributeGroup-result/index?${scene}`
      });
    }
  }
  // 查看我的拼团
  handleToMyGroup() {
    const location =
      window.location.href
        .replace(/[?,&]code.*state/i, "")
        .replace(/&uid=\d*/, "") +
      "&uid=" +
      this.uid;
    this.signatureWechatShare(location);
    exchangeMsgToXcx(this.uid);
    this.changeUrlUid(this.uid);
  }
  signatureWechatShare(location: string) {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const shareUrl: string =
      (CONFIG.shareUrl as any)[env] +
      (CONFIG.appId as any)[env] +
      '&redirect_uri=' +
      encodeURIComponent(location) +
      '&response_type=code&scope=snsapi_base&state=state#wechat_redirect';
    const shareObject: ShareObjectInterface = {
      title: this.title.replace(/<br\/>/g, '\n'),
      desc: pickHtmlTextContent(this.section.courseDesc),
      link: shareUrl,
      imgUrl: this.coverTiny
    };
    this.changePosterUrl(shareUrl);
    wechatSignUp(this.signature, shareObject);
  }
  // 显示/隐藏分享popup
  handleRedirectToSharePage(parentUid: string) {
    // 跳转到小程序分享页面
    const broadcastId = getUrlParam('broadcastId');
    const posterName = this.posterName;
    // 团购分享出去的链接需要带上团长id
    // 如果是从独立版小麦秀小程序进入的分享页,那么分享的时候就跳到独立版小麦秀的分享页
    if (origin === 'ordinary') {
      window.wx.miniProgram.redirectTo({
        url: `/pages/activity/activityShare/main?id=${broadcastId}&parentUid=${parentUid}`
      });
    } else {
      window.wx.miniProgram.redirectTo({
        url: `/pages/user-share/index?broadcastId=${broadcastId}&parentUid=${parentUid}&name=${posterName}`
      });
    }
  }
  // 跳到我的奖励
  toMyReward() {
    if (window.__wxjs_environment === 'miniprogram') {
      const distributorId = getUrlParam('distributorId');
      let shareFlag = 'YES';
      // 未报名，已支付/未支付且取消报名
      if (this.section.distributeGroupMode === 'AFTER_BUY' && (this.cancel || !this.uid)) {
        shareFlag = 'NO';
      } else if (this.activityStatus === 'endIng' || this.activityStatus === 'noStart') {
        // 活动结束也没有分享
        shareFlag = 'NO';
      }
      const scene =
        `activityId=${this.broadcastId}&templateType=${this.templateType}&nickname=${this.nickname}&avatar=${
          this.avatar
        }&shareFlag=${shareFlag}&distributorId=${distributorId ? `${distributorId}` : `-1`}` + (this.uid ? `&parentUid=${this.uid}` : ``);
      if (this.nickname) {
        window.wx.miniProgram.navigateTo({
          url: `/pages/my-reward/index?${scene}`
        });
      } else {
        Vue.$loading.show('正在加载..');
        setTimeout(() => {
          window.wx.miniProgram.navigateTo({
            url: `/pages/my-reward/index?${scene}`
          });
          Vue.$loading.hide();
        }, 3000);
      }
    }
  }
  // 查看我的报名记录
  toMyRecord() {
    // 已报名,跳转到小程序支付结结果页面
    if (window.__wxjs_environment === 'miniprogram') {
      const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
      const distributorId = getUrlParam('distributorId');
      let shareFlag = 'YES';
      // 未报名，已支付/未支付且取消报名
      if (this.section.distributeGroupMode === 'AFTER_BUY' && (this.cancel || !this.uid)) {
        shareFlag = 'NO';
      } else if (this.activityStatus === 'endIng' || this.activityStatus === 'noStart') {
        // 活动结束也没有分享
        shareFlag = 'NO';
      }
      let qrCodeUrl = this.qrCodeUrl;
      if (env === 'gray') {
        qrCodeUrl = qrCodeUrl.replace('xmshow', 'xmshow/gray');
      }
      const scene =
        `activityId=${this.broadcastId}&qrCodeUrl=${encodeURIComponent(qrCodeUrl)}&templateType=${this.templateType}&nickname=${this.nickname}&avatar=${
          this.avatar
        }&shareFlag=${shareFlag}&distributorId=${distributorId ? `${distributorId}` : `-1`}` + (this.uid ? `&parentUid=${this.uid}` : ``);
      window.wx.miniProgram.navigateTo({
        url: `/pages/pay-distributeGroup-result/index?${scene}`
      });
    }
  }
  toInvite(parentUid: string = '') {
    if (this.activityStatus === 'noStart') {
      Vue.$toast.error('活动未开始');
    } else {
      if (this.nickname) {
        const broadcastId = getUrlParam('broadcastId');
        const distributorId = getUrlParam('distributorId');
        const scene = `activityId=${broadcastId}&templateType=${this.templateType}&nickname=${this.nickname}&avatar=${this.avatar}&distributorId=${distributorId ? `${distributorId}` : `-1`}&parentUid=${parentUid}`;
        if (window.__wxjs_environment === 'miniprogram') {
          window.wx.miniProgram.navigateTo({
            url: `/pages/poster/index?${scene}`
          });
        }
      } else {
        Vue.$loading.show('正在加载..');
        setTimeout(() => {
          this.toMiniprogram(parentUid);
          Vue.$loading.hide();
        }, 3000);
      }
    }
  }
  toMiniprogram(parentUid: string = '') {
    const broadcastId = getUrlParam('broadcastId');
    const distributorId = getUrlParam('distributorId');
    const scene =
      `activityId=${broadcastId}&nickname=${this.nickname}&avatar=${this.avatar}` +
      `&distributorId=${distributorId ? `${distributorId}` : `-1`}` +
      `&parentUid=${parentUid}&templateType=${this.templateType}`;
    if (window.__wxjs_environment === 'miniprogram') {
      window.wx.miniProgram.navigateTo({
        url: `/pages/poster/index?${scene}`
      });
    }
  }

  getActivityStatus() {
    const activityDeadline: number = this.deadline;
    const activityStartTime: number = this.startTime;
    const nowTimestamp: number = new Date().valueOf();
    if (activityStartTime > nowTimestamp) {
      this.activityStatus = 'noStart';
    } else {
      if (nowTimestamp < activityDeadline) {
        this.activityStatus = 'startIng';
      } else {
        this.activityStatus = 'endIng';
      }
    }
  }
}
